import { render, staticRenderFns } from "./CardSupplyChainTransparency.vue?vue&type=template&id=21b696ec&scoped=true&"
import script from "./CardSupplyChainTransparency.vue?vue&type=script&lang=js&"
export * from "./CardSupplyChainTransparency.vue?vue&type=script&lang=js&"
import style0 from "./CardSupplyChainTransparency.vue?vue&type=style&index=0&id=21b696ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b696ec",
  null
  
)

export default component.exports